export const mockData: any = {
  faqList: [
    {
      sNo: "01",
      question: "What are the major infrastructure projects driving Singapore development?",
    },
    {
      sNo: "02",
      question: "How is sustainability being integrated into infrastructure planning and execution",
    },
    {
      sNo: "03",
      question: "What financing products are supporting green and innovative infrastructure",
    },
    {
      sNo: "04",
      question: "How is digital infrastructure evolving to meet growing demands",
    },
    {
      sNo: "05",
      question: "What are the key challenges and opportunities in building sustainable infrastructure",
    },
  ],
};
